import { render, staticRenderFns } from "./Assesores.vue?vue&type=template&id=b16d5fd2&scoped=true&"
import script from "./Assesores.vue?vue&type=script&lang=js&"
export * from "./Assesores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16d5fd2",
  null
  
)

export default component.exports